import './press-overview.scss';

import { Pagination } from '../../components/pagination/pagination';

class PressOverview {
    constructor (element) {
        this.$pressOverview = element;

        this.pagination = new Pagination(this.$pressOverview, {
            paginationAttr: '[data-press-overview="pagination"]',
            selectPaginationAttr: '[data-press-overview="select-pagination"]'
        });
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.pagination.check((action) => {
            window.location.href = action;
        });
    }
}

export { PressOverview };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $pressOverview = $context.querySelector('[data-press-overview="root"]');

        if ($pressOverview) {
            const pressOverview = new PressOverview($pressOverview);
            pressOverview.initialize();
        }
    }
});
